export default __webpack_public_path__ + "static/media/feedback_mobile2.c0397d48.svg";